import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";

import { getMaritalInformationRes } from "core/http/service/personnelInformation/resTypes";

interface InitialState {
  status: ReduxStateType;
  data: getMaritalInformationRes;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: {
    familyMembers: [],
    maritalStatus: "",
  },
};

const getMaritalInformationSlice = createSlice({
  name: "getMaritalInformation",
  initialState,
  reducers: {
    getMaritalInformationStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getMaritalInformationSuccess: (
      state,
      action: PayloadAction<getMaritalInformationRes>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getMaritalInformationFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetMaritalInformation: () => {
      return { ...initialState };
    },
  },
});

export const {
  getMaritalInformationStart,
  getMaritalInformationSuccess,
  getMaritalInformationFailed,
  resetMaritalInformation,
} = getMaritalInformationSlice.actions;

export default getMaritalInformationSlice.reducer;
